<template>
  <v-card>
    <v-card-text>
      <v-data-table
        v-bind="dataTableAttrs"
        :headers="headersShown"
        :items="list"
        :loading="isLoading"
        :options.sync="options"
        :server-items-length="total"
        :items-per-page.sync="itemsPerPage"
        v-model="selectedItems"
        @update:items-per-page="handleItemsPerPageUpdated"
        :show-select="false"
      >
        <template v-slot:top>
          <rs-table-title-bar
            v-if="$refs.headSearch"
            title="Admin Bildirim Batch"
            icon="mdi-bell-outline"
            @clear-filters="$refs.headSearch.reset"
            @reload="loadList"
            hide-edit
            :search.sync="search.query"
            v-bind="titleBarAttrs"
          ></rs-table-title-bar>
        </template>

        <!-- eslint-disable-next-line -->
        <template v-slot:body.prepend="{ headers }">
          <rs-table-head-search
            :headers="headers"
            :search.sync="search"
            ref="headSearch"
          />
        </template>

        <!-- eslint-disable-next-line -->
        <template v-slot:item.detail="{ item }">
          <router-link
            class="btn btn-icon btn-sm btn-clean"
            :to="{
              name: 'admin.notification-batches.show',
              params: { id: item.id },
            }"
          >
            <i class="menu-icon mdi mdi-eye"></i>
          </router-link>
        </template>

        <!-- eslint-disable-next-line -->
        <template v-slot:item.body="{ value }">
          <rs-table-cell-string :value="value" :limit="60" />
        </template>

        <!-- eslint-disable-next-line -->
        <template v-slot:item.created_at="{ value }">
          <rs-table-cell-date show-time :value="value" />
        </template>

        <!-- eslint-disable-next-line -->
        <template v-slot:item.delivery_provider="{ value }">
          <span>{{ formatProvider(value) }}</span>
        </template>

        <!-- eslint-disable-next-line -->
        <template v-slot:item.needs_attention_count="{ value }">
          <v-chip
            v-if="Number(value) > 0"
            small
            color="warning"
            text-color="white"
          >
            {{ value }}
          </v-chip>
          <span v-else>0</span>
        </template>
      </v-data-table>
    </v-card-text>
  </v-card>
</template>

<script>
import { debounce } from "@/core/plugins/debounce";
import { filtersToURL } from "@/view/mixins";
import { mapGetters } from "vuex";

export default {
  name: "AdminNotificationBatchList",
  mixins: [filtersToURL],
  computed: {
    ...mapGetters(["notificationChannelListIds"]),
  },
  data() {
    return {
      options: {
        sortBy: ["created_at"],
        sortDesc: [true],
      },
      dataTableAttrs: {
        footerProps: {
          disableItemsPerPage: false,
        },
      },
      headers: [
        {
          text: "",
          value: "detail",
          searchable: false,
          sortable: false,
          width: "30px",
          align: "center",
        },
        {
          text: "ID",
          value: "id",
          searchable: "number",
          align: "end",
          width: "80px",
          notPrice: true,
        },
        {
          text: "Kanal",
          value: "notification_channel",
          searchable: "select",
          options: () => this.notificationChannelListIds,
          itemText: "name",
          itemValue: "id",
          searchValue: "notification_channel_id",
          width: "150px",
        },
        {
          text: "Servis",
          value: "delivery_provider",
          searchable: "text",
          width: "130px",
        },
        {
          text: "Olusturan",
          value: "created_by_name",
          searchable: "text",
          width: "160px",
        },
        {
          text: "Baslik",
          value: "subject",
          searchable: "text",
          width: "200px",
        },
        {
          text: "Mesaj",
          value: "body",
          searchable: "text",
          width: "260px",
        },
        {
          text: "Hedef",
          value: "target_count",
          searchable: "number",
          align: "end",
          width: "80px",
          notPrice: true,
        },
        {
          text: "Olusan",
          value: "created_count",
          searchable: false,
          align: "end",
          width: "80px",
          notPrice: true,
        },
        {
          text: "Bekleyen",
          value: "pending_count",
          searchable: false,
          align: "end",
          width: "90px",
          notPrice: true,
        },
        {
          text: "Gonderilen",
          value: "sent_count",
          searchable: false,
          align: "end",
          width: "100px",
          notPrice: true,
        },
        {
          text: "Hata",
          value: "error_count",
          searchable: false,
          align: "end",
          width: "70px",
          notPrice: true,
        },
        {
          text: "Dikkat",
          value: "needs_attention_count",
          searchable: false,
          align: "end",
          width: "80px",
          notPrice: true,
        },
        {
          text: "Tarih",
          value: "created_at",
          searchable: "date",
          width: "160px",
        },
      ],
      titleBarAttrs: {},
    };
  },
  watch: {
    options: {
      handler() {
        this.setURLParams();
      },
      deep: true,
    },
    search: {
      handler: debounce(function () {
        this.options.page = 1;
        this.setURLParams();
      }, 250),
      deep: true,
    },
  },
  mounted() {
    this.loadList();
  },
  methods: {
    formatProvider(value) {
      if (!value) {
        return "-";
      }

      const map = {
        goldsms: "GoldSMS",
        mailer: "Laravel Mailer",
        onesignal: "OneSignal",
      };

      return map[value] || value;
    },
    getParams() {
      return this.buildSearchParams(this.search, this.options);
    },
    loadList() {
      if (this.isLoading) {
        return;
      }

      this.isLoading = true;
      this.list = [];
      this.footTotals = [];

      const params = this.getParams();

      this.$api
        .query("api-super-admin/admin-notification-batches", { params })
        .then((response) => {
          this.loadListFromResponse(response);
        })
        .catch((error) => {
          this.handleError(error);
        })
        .finally(() => (this.isLoading = false));
    },
  },
};
</script>
